<template>
  <div class="Page">
    <HeaderSection 
      title="Contact"
      :closeLinkTo="{ name: 'home'}">
      <p>
        E-mail: <a href="mailto:info@energieke-verhalen.nl">info@energieke-verhalen.nl</a>
      </p>
    </HeaderSection>
    <ContentSection>
      <ContentTip>
        <strong>Ben je hier voor het doorgeven van een project?</strong>
        <br/>
        Geweldig! Het aanmelden van een project gaat het beste via de pagina die daarvoor is ingericht.
        <Link
          arrow 
          label="Project aanmelden"
          :to="{name: 'page-aanmaken'}" />
      </ContentTip>
    </ContentSection>
    <!-- <ContentSection>
      <SectionHeader label="Contact Informatie" />
      <p>
        E-mail: info@energieke-verhalen.nl
      </p>
    </ContentSection> -->
  </div>
</template>

<script>
import ContentSection from '@/components/section/ContentSection';
import HeaderSection from '@/components/section/HeaderSection';
// import SectionHeader from '@/components/section/Header';
import ContentTip from '@/components/content/Tip';
import Link from '@/components/Link';

export default {
  name: 'PageContact',
  components: {
    HeaderSection,
    ContentSection,
    // SectionHeader,
    ContentTip,
    Link
  }
}
</script>

<style lang="scss" scoped>
  a {
    color: $color_primary;

    &:hover {
      color: $metro_oranje;
    }
  } 
</style>

